(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["py-look-builder-v5"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('py-manual-look-grid')) {
    customElements.define('py-manual-look-grid', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-py-look-filter]');
          if (!button || !this.contains(button)) return;
          const filter = button.dataset.pyLookFilter;
          for (const option of this.querySelectorAll('[data-py-look-filter]')) {
            const active = option === button;
            option.classList.toggle('is-active', active);
            option.setAttribute('aria-pressed', String(active));
          }
          for (const card of this.querySelectorAll('[data-py-look-card]')) {
            const tags = card.dataset.pyLookTags.split(/\s+/);
            card.hidden = filter !== 'all' && !tags.includes(filter);
          }
        });
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-py-look-card]');
          if (card && card.hidden) this.querySelector('[data-py-look-filter="all"]')?.click();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["py-look-collection-v7"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('py-look-collection-v7')) {
    customElements.define('py-look-collection-v7', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;

        if (!this.querySelector('[data-pylc-ready]')) {
          this.observer?.disconnect();
          this.observer = new MutationObserver(() => this.connectedCallback());
          this.observer.observe(this, { childList: true, subtree: true });
          return;
        }

        this.observer?.disconnect();
        this.button = this.querySelector('[data-pylc-add]');

        if (!this.button) return;

        this.bound = true;
        this.listeners = new AbortController();
        this.label = this.querySelector('[data-pylc-add-label]');
        this.defaultLabel = this.defaultLabel || this.label.textContent;
        this.message = this.querySelector('[data-pylc-message]');
        this.currency = this.dataset.currency;

        try {
          this.formatter = new Intl.NumberFormat(
            this.dataset.locale || document.documentElement.lang || 'en',
            {
              style: 'currency',
              currency: this.currency,
              currencyDisplay: 'code'
            }
          );
        } catch {
          this.formatter = null;
        }

        this.addEventListener('change', event => {
          if (this.busy) return;

          if (event.target.matches('[data-pylc-select]')) {
            event.target
              .closest('[data-pylc-row]')
              .querySelector('[data-pylc-check]')
              .checked = true;
          }

          if (!this.uncertain) this.message.textContent = '';
          this.update();
        }, { signal: this.listeners.signal });

        this.addEventListener('click', event => {
          if (event.target.closest('[data-pylc-add]')) this.addToCart();

          const all = event.target.closest('[data-pylc-select-all]');
          const clear = event.target.closest('[data-pylc-clear]');

          if ((all || clear) && !this.busy) {
            for (const check of this.querySelectorAll('[data-pylc-check]')) {
              check.checked = Boolean(all) && !check.disabled;
            }
            this.update();
          }
        }, { signal: this.listeners.signal });

        this.update();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.listeners?.abort();
        this.bound = false;

        if (this.busy) {
          this.uncertain = true;
          this.requestController?.abort();
        }
      }

      money(amount) {
        return this.formatter
          ? this.formatter.format(amount / 100)
          : `${this.currency || ''} ${(amount / 100).toFixed(2)}`.trim();
      }

      update() {
        const merged = new Map();
        let selectedTotal = 0;
        let fullTotal = 0;
        let complete = true;
        let unavailable = 0;
        const rows = this.querySelectorAll('[data-pylc-row]');

        for (const row of rows) {
          const select = row.querySelector('[data-pylc-select]');
          const option = select?.selectedOptions[0];
          const check = row.querySelector('[data-pylc-check]');
          const quantity = Number(row.dataset.quantity);
          const price = Number(option?.dataset.price);

          const priced =
            option?.dataset.price !== undefined &&
            option.dataset.price !== '' &&
            Number.isFinite(price) &&
            price >= 0 &&
            Number.isInteger(quantity) &&
            quantity > 0;

          const validId = /^\d+$/.test(option?.value || '');
          const available = priced && validId && option.dataset.available === 'true';

          if (priced && validId) {
            fullTotal += price * quantity;
          } else {
            complete = false;
          }

          if (!available) {
            unavailable++;
            check.checked = false;
          }

          check.disabled = !available || Boolean(this.busy);
          select.disabled = Boolean(this.busy) || select.options.length < 2;

          const status = row.querySelector('[data-pylc-row-status]');
          status.hidden = available;
          status.textContent = priced ? this.dataset.unavailable : this.dataset.pending;

          row.querySelector('[data-pylc-row-price]').textContent = priced
            ? (option.dataset.money || this.money(price * quantity))
            : this.dataset.pending;

          if (option?.dataset.url) {
            for (const link of row.querySelectorAll('[data-pylc-product-link]')) {
              link.href = option.dataset.url;
            }
          }

          const thumb = this.querySelector(
            `[data-pylc-thumb-index="${row.dataset.index}"]`
          );

          if (thumb && option?.dataset.url) {
            const link = thumb.querySelector('[data-pylc-thumb-link]');
            if (link) link.href = option.dataset.url;
          }

          if (option?.dataset.image) {
            for (const photo of [
              row.querySelector('.py-look-collection-v7__product-photo'),
              thumb?.querySelector('img')
            ]) {
              if (photo && photo.getAttribute('src') !== option.dataset.image) {
                photo.removeAttribute('srcset');
                photo.src = option.dataset.image;
              }
            }
          }

          if (!check.checked || !available) continue;

          selectedTotal += price * quantity;
          const item = merged.get(option.value) || {
            id: option.value,
            quantity: 0
          };

          item.quantity += quantity;
          merged.set(option.value, item);
        }

        this.items = [...merged.values()];

        this.querySelector('[data-pylc-full-total]').textContent =
          rows.length && complete ? this.money(fullTotal) : this.dataset.pending;

        this.querySelector('[data-pylc-selected-total]').textContent =
          this.money(selectedTotal);

        this.button.disabled =
          Boolean(this.busy) ||
          Boolean(this.uncertain) ||
          !this.items.length;

        this.label.textContent = this.busy
          ? this.dataset.loading
          : this.defaultLabel;

        this.querySelector('[data-pylc-partial]').hidden = unavailable === 0;

        for (const control of this.querySelectorAll(
          '[data-pylc-select-all], [data-pylc-clear]'
        )) {
          control.disabled = Boolean(this.busy);
        }
      }

      async addToCart() {
        if (this.busy || this.uncertain) return;

        this.update();

        if (!this.items.length) {
          this.message.textContent = this.dataset.empty;
          return;
        }

        const items = this.items.map(item => ({ ...item }));
        this.busy = true;
        this.message.textContent = '';
        this.requestController = new AbortController();
        this.update();

        let sent = false;

        try {
          const root = window.Shopify?.routes?.root || '/';
          sent = true;

          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items }),
            signal: this.requestController.signal
          });

          const result = await response.json();

          if (!response.ok) {
            this.message.textContent =
              typeof result.description === 'string'
                ? result.description
                : typeof result.message === 'string'
                  ? result.message
                  : this.dataset.error;

            if (response.status >= 500) {
              this.uncertain = true;
              this.message.textContent += ` ${this.dataset.uncertain}`;
              this.querySelector('[data-pylc-cart]').hidden = false;
            }

            return;
          }

          this.message.textContent = this.dataset.success;
          this.querySelector('[data-pylc-cart]').hidden = false;

          document.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );
        } catch {
          this.uncertain = sent;
          this.message.textContent = sent
            ? this.dataset.uncertain
            : this.dataset.error;

          this.querySelector('[data-pylc-cart]').hidden = !sent;
        } finally {
          this.busy = false;
          this.requestController = null;
          this.update();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["py-look-collection-v8"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('py-look-collection-v8')) {
    customElements.define('py-look-collection-v8', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;

        if (!this.querySelector('[data-pylc-ready]')) {
          this.observer?.disconnect();
          this.observer = new MutationObserver(() => this.connectedCallback());
          this.observer.observe(this, { childList: true, subtree: true });
          return;
        }

        this.observer?.disconnect();
        this.button = this.querySelector('[data-pylc-add]');

        if (!this.button) return;

        this.bound = true;
        this.listeners = new AbortController();
        this.label = this.querySelector('[data-pylc-add-label]');
        this.defaultLabel = this.defaultLabel || this.label.textContent;
        this.message = this.querySelector('[data-pylc-message]');
        this.currency = this.dataset.currency;

        try {
          this.formatter = new Intl.NumberFormat(
            this.dataset.locale || document.documentElement.lang || 'en',
            {
              style: 'currency',
              currency: this.currency,
              currencyDisplay: 'code'
            }
          );
        } catch {
          this.formatter = null;
        }

        this.addEventListener('change', event => {
          if (this.busy) return;

          if (event.target.matches('[data-pylc-select]') && event.target.closest('[data-pylc-row]').dataset.kind === 'look') {
            event.target
              .closest('[data-pylc-row]')
              .querySelector('[data-pylc-check]')
              .checked = true;
          }

          if (!this.uncertain) this.message.textContent = '';
          this.update();
        }, { signal: this.listeners.signal });

        this.addEventListener('click', event => {
          if (event.target.closest('[data-pylc-add]')) this.addToCart();

          const all = event.target.closest('[data-pylc-select-all]');
          const clear = event.target.closest('[data-pylc-clear]');

          if ((all || clear) && !this.busy) {
            for (const check of this.querySelectorAll('[data-pylc-check]')) {
              check.checked = Boolean(all) && !check.disabled && check.closest('[data-pylc-row]').dataset.kind === 'look';
            }
            this.update();
          }
        }, { signal: this.listeners.signal });

        this.update();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.listeners?.abort();
        this.bound = false;

        if (this.busy) {
          this.uncertain = true;
          this.requestController?.abort();
        }
      }

      money(amount) {
        return this.formatter
          ? this.formatter.format(amount / 100)
          : `${this.currency || ''} ${(amount / 100).toFixed(2)}`.trim();
      }

      update() {
        const merged = new Map();
        let selectedTotal = 0;
        let fullTotal = 0;
        let fullCompare = 0;
        let baseCount = 0;
        let selectedCount = 0;
        const eligibleUnits = [];
        let complete = true;
        let unavailable = 0;
        const rows = this.querySelectorAll('[data-pylc-row]');

        for (const row of rows) {
          const select = row.querySelector('[data-pylc-select]');
          const option = select?.selectedOptions[0];
          const check = row.querySelector('[data-pylc-check]');
          const quantity = Number(row.dataset.quantity);
          const price = Number(option?.dataset.price);

          const priced =
            option?.dataset.price !== undefined &&
            option.dataset.price !== '' &&
            Number.isFinite(price) &&
            price >= 0 &&
            Number.isInteger(quantity) &&
            quantity > 0;

          const validId = /^\d+$/.test(option?.value || '');
          const available = priced && validId && option.dataset.available === 'true';

          const base = row.dataset.kind === 'look';
          const compare = Math.max(price || 0, Number(option?.dataset.compare) || 0);
          if (base) {
            baseCount++;
            if (priced && validId) {
              fullTotal += price * quantity;
              fullCompare += compare * quantity;
            } else {
              complete = false;
            }
          }

          if (!available) {
            if (base) unavailable++;
            check.checked = false;
          }

          check.disabled = !available || Boolean(this.busy);
          select.disabled = Boolean(this.busy) || select.options.length < 2;

          const status = row.querySelector('[data-pylc-row-status]');
          status.hidden = available;
          status.textContent = priced ? this.dataset.unavailable : this.dataset.pending;

          row.querySelector('[data-pylc-row-price]').textContent = priced
            ? (option.dataset.money || this.money(price * quantity))
            : this.dataset.pending;

          const compareNode = row.querySelector('[data-pylc-row-compare]');
          if (compareNode) {
            compareNode.hidden = !priced || compare <= price;
            compareNode.textContent = priced ? this.money(compare * quantity) : '';
          }

          if (option?.dataset.url) {
            for (const link of row.querySelectorAll('[data-pylc-product-link]')) {
              link.href = option.dataset.url;
            }
          }

          const thumb = this.querySelector(
            `[data-pylc-thumb-index="${row.dataset.index}"]`
          );

          if (thumb && option?.dataset.url) {
            const link = thumb.querySelector('[data-pylc-thumb-link]');
            if (link) link.href = option.dataset.url;
          }

          if (option?.dataset.image) {
            for (const photo of [
              row.querySelector('.py-look-collection-v8__product-photo'),
              thumb?.querySelector('img')
            ]) {
              if (photo && photo.getAttribute('src') !== option.dataset.image) {
                photo.removeAttribute('srcset');
                photo.src = option.dataset.image;
              }
            }
          }

          if (!check.checked || !available) continue;

          selectedTotal += price * quantity;
          selectedCount += quantity;
          if (this.dataset.promo === 'true' && row.dataset.eligible === 'true') {
            eligibleUnits.push({ price, quantity });
          }
          const item = merged.get(option.value) || {
            id: option.value,
            quantity: 0
          };

          item.quantity += quantity;
          merged.set(option.value, item);
        }

        this.items = [...merged.values()];

        this.querySelector('[data-pylc-full-total]').textContent =
          baseCount && complete ? this.money(fullTotal) : this.dataset.pending;
        const fullCompareNode = this.querySelector('[data-pylc-full-compare]');
        fullCompareNode.hidden = !baseCount || !complete || fullCompare <= fullTotal;
        fullCompareNode.textContent = this.money(fullCompare);

        this.querySelector('[data-pylc-selected-total]').textContent =
          this.money(selectedTotal);

        this.querySelector('[data-pylc-selection-count]').textContent = (this.dataset.itemsLabel || '').replace('{count}', selectedCount);
        const promoSummary = this.querySelector('[data-pylc-promo-summary]');
        let savings = 0;
        if (promoSummary) {
          promoSummary.hidden = false;
          eligibleUnits.sort((a, b) => a.price - b.price);
          const eligibleCount = eligibleUnits.reduce((sum, unit) => sum + unit.quantity, 0);
          const freeCount = Math.floor(eligibleCount / 3);
          let remaining = freeCount;
          for (const unit of eligibleUnits) {
            const freeUnits = Math.min(unit.quantity, remaining);
            savings += freeUnits * unit.price;
            remaining -= freeUnits;
            if (!remaining) break;
          }
          const threshold = Math.max(3, Math.ceil(eligibleCount / 3) * 3);
          const missing = 3 - eligibleCount % 3;
          const progress = this.querySelector('[data-pylc-progress]');
          progress.max = threshold;
          progress.value = eligibleCount;
          this.querySelector('[data-pylc-eligible-count]').textContent = `${eligibleCount} / ${threshold} ${this.dataset.eligibleLabel}`;
          this.querySelector('[data-pylc-promo-hint]').textContent = freeCount
            ? (freeCount === 1 ? this.dataset.unlockedOne : this.dataset.unlocked).replace('{count}', freeCount).replace('{savings}', this.money(savings))
            : (missing === 1 ? this.dataset.addOne : this.dataset.addMore).replace('{count}', missing);
          this.querySelector('[data-pylc-savings-row]').hidden = freeCount === 0;
          this.querySelector('[data-pylc-estimated-row]').hidden = freeCount === 0;
          this.querySelector('[data-pylc-promo-savings]').textContent = `−${this.money(savings)}`;
          this.querySelector('[data-pylc-estimated-total]').textContent = this.money(selectedTotal - savings);
          this.button.dataset.promoUnlocked = String(freeCount > 0);
        }

        this.button.disabled =
          Boolean(this.busy) ||
          Boolean(this.uncertain) ||
          !this.items.length;

        this.label.textContent = this.busy
          ? this.dataset.loading
          : savings > 0
            ? this.dataset.promoCta.replace('{savings}', this.money(savings)).replace('{total}', this.money(selectedTotal - savings))
            : this.defaultLabel;

        this.querySelector('[data-pylc-partial]').hidden = unavailable === 0;

        for (const control of this.querySelectorAll(
          '[data-pylc-select-all], [data-pylc-clear]'
        )) {
          control.disabled = Boolean(this.busy);
        }
      }

      async addToCart() {
        if (this.busy || this.uncertain) return;

        this.update();

        if (!this.items.length) {
          this.message.textContent = this.dataset.empty;
          return;
        }

        const items = this.items.map(item => ({ ...item }));
        this.busy = true;
        this.message.textContent = '';
        this.requestController = new AbortController();
        this.update();

        let sent = false;

        try {
          const root = window.Shopify?.routes?.root || '/';
          sent = true;

          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items }),
            signal: this.requestController.signal
          });

          const result = await response.json();

          if (!response.ok) {
            this.message.textContent =
              typeof result.description === 'string'
                ? result.description
                : typeof result.message === 'string'
                  ? result.message
                  : this.dataset.error;

            if (response.status >= 500) {
              this.uncertain = true;
              this.message.textContent += ` ${this.dataset.uncertain}`;
              this.querySelector('[data-pylc-cart]').hidden = false;
            }

            return;
          }

          this.message.textContent = this.dataset.success;
          this.querySelector('[data-pylc-cart]').hidden = false;

          document.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );
        } catch {
          this.uncertain = sent;
          this.message.textContent = sent
            ? this.dataset.uncertain
            : this.dataset.error;

          this.querySelector('[data-pylc-cart]').hidden = !sent;
        } finally {
          this.busy = false;
          this.requestController = null;
          this.update();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["py-look-detail-v3"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('py-look-gallery-v3')) {
    customElements.define('py-look-gallery-v3', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-py-gallery-thumb]');
          if (!button || !this.contains(button)) return;
          const index = button.dataset.index;
          for (const thumb of this.querySelectorAll('[data-py-gallery-thumb]')) {
            const active = thumb.dataset.index === index;
            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-pressed', String(active));
          }
          for (const panel of this.querySelectorAll('[data-py-gallery-panel]')) {
            const active = panel.dataset.index === index;
            panel.hidden = !active;
            panel.classList.toggle('is-active', active);
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["py-look-detail-v4"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('py-look-detail-v4')) {
    customElements.define('py-look-detail-v4', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const selectAll = event.target.closest('[data-py-select-all]');
          const clearAll = event.target.closest('[data-py-clear-all]');
          if (!selectAll && !clearAll) return;
          const picker = this.querySelector('py-look-picker');
          if (!picker) return;
          for (const check of picker.querySelectorAll('[data-py-item] [data-py-check]:not(:disabled)')) {
            check.checked = Boolean(selectAll);
          }
          if (typeof picker.update === 'function') picker.update();
        });
      }
    });
  }
  if (!customElements.get('py-look-gallery-v4')) {
    customElements.define('py-look-gallery-v4', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-py-gallery-thumb]');
          if (!button || !this.contains(button)) return;
          const index = button.dataset.index;
          for (const thumb of this.querySelectorAll('[data-py-gallery-thumb]')) {
            const active = thumb.dataset.index === index;
            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-pressed', String(active));
          }
          for (const panel of this.querySelectorAll('[data-py-gallery-panel]')) {
            const active = panel.dataset.index === index;
            panel.hidden = !active;
            panel.classList.toggle('is-active', active);
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["py-look-detail-v5"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('py-look-picker-v5')) {
    customElements.define('py-look-picker-v5', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        if (!this.querySelector('[data-py-add]')) {
          this.observer = new MutationObserver(() => {
            if (!this.querySelector('[data-py-add]')) return;
            this.observer.disconnect();
            this.connectedCallback();
          });
          this.observer.observe(this, {childList: true, subtree: true});
          return;
        }
        this.initialized = true;
        this.addButton = this.querySelector('[data-py-add]');
        this.addLabel = this.querySelector('[data-py-add-label]');
        this.total = this.querySelector('[data-py-total]');
        this.message = this.querySelector('[data-py-message]');
        this.addEventListener('change', () => this.update());
        this.addEventListener('click', (event) => {
          const selectAll = event.target.closest('[data-py-select-all]');
          const clearAll = event.target.closest('[data-py-clear-all]');
          if (selectAll || clearAll) {
            for (const check of this.querySelectorAll('[data-py-check]')) check.checked = Boolean(selectAll);
            this.update();
          }
          if (event.target.closest('[data-py-add]')) this.addToCart();
        });
        this.update();
      }
      update() {
        let selected = 0;
        let unavailable = 0;
        let subtotal = 0;
        const merged = new Map();
        for (const row of this.querySelectorAll('[data-py-item]')) {
          const option = row.querySelector('[data-py-variant]')?.selectedOptions[0];
          const check = row.querySelector('[data-py-check]');
          if (!option || !check) continue;
          const quantity = Number(option.dataset.quantity || 1);
          const available = option.dataset.available === 'true' && /^\d+$/.test(option.value);
          const status = row.querySelector('[data-py-row-status]');
          if (status) {
            status.hidden = available;
            status.textContent = option.dataset.status || this.dataset.comingSoon;
          }
          const price = row.querySelector('[data-py-price]');
          if (price) price.textContent = Number(option.dataset.price) > 0 ? option.dataset.money : this.dataset.pricePending;
          const photo = row.querySelector('.py-look-item__photo');
          if (photo && option.dataset.image) {
            photo.removeAttribute('srcset');
            photo.src = option.dataset.image;
          }
          if (!check.checked) continue;
          selected += quantity;
          if (!available) {
            unavailable += quantity;
            continue;
          }
          subtotal += Number(option.dataset.price || 0) * quantity;
          const current = merged.get(option.value) || { id: option.value, quantity: 0 };
          current.quantity += quantity;
          merged.set(option.value, current);
        }
        this.items = [...merged.values()];
        const purchasable = this.items.length > 0;
        this.addButton.disabled = this.busy || !purchasable;
        this.addLabel.textContent = this.busy ? this.dataset.loading : purchasable ? this.addLabel.dataset.default : `${this.addLabel.dataset.default} · ${this.dataset.comingSoon}`;
        this.total.hidden = !purchasable;
        this.querySelector('.py-look-detail-v5__note').hidden = !purchasable;
        this.querySelector('[data-py-separator]').hidden = !purchasable;
        this.total.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(subtotal / 100);
        this.querySelector('[data-py-count]').textContent = (this.dataset.countLabel || '([count])').replace('[count]', selected);
        const note = this.querySelector('[data-py-availability]');
        note.hidden = unavailable === 0;
        note.textContent = this.dataset.draftNote;
      }
      async addToCart() {
        if (this.busy || !this.items?.length) return;
        const items = this.items.map((item) => ({ ...item }));
        this.busy = true;
        this.message.textContent = '';
        this.update();
        let sent = false;
        try {
          const root = window.Shopify?.routes?.root || '/';
          sent = true;
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          const result = await response.json();
          if (!response.ok) {
            this.message.textContent = result.description || result.message || this.dataset.error;
            return;
          }
          this.message.textContent = this.dataset.success;
          this.querySelector('[data-py-cart-link]').hidden = false;
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch {
          this.message.textContent = sent ? this.dataset.uncertain : this.dataset.error;
        } finally {
          this.busy = false;
          this.update();
        }
      }
    });
  }
  if (!customElements.get('py-look-gallery-v5')) {
    customElements.define('py-look-gallery-v5', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-py-gallery-thumb]');
          if (!button || !this.contains(button)) return;
          const index = button.dataset.index;
          for (const thumb of this.querySelectorAll('[data-py-gallery-thumb]')) {
            const active = thumb.dataset.index === index;
            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-pressed', String(active));
          }
          for (const panel of this.querySelectorAll('[data-py-gallery-panel]')) {
            const active = panel.dataset.index === index;
            panel.hidden = !active;
            panel.classList.toggle('is-active', active);
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["py-look-detail-v6"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('py-look-picker-v6')) {
    customElements.define('py-look-picker-v6', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        if (!this.querySelector('[data-py-add]')) {
          this.observer = new MutationObserver(() => {
            if (!this.querySelector('[data-py-add]')) return;
            this.observer.disconnect();
            this.connectedCallback();
          });
          this.observer.observe(this, {childList: true, subtree: true});
          return;
        }
        this.initialized = true;
        this.addButton = this.querySelector('[data-py-add]');
        this.addLabel = this.querySelector('[data-py-add-label]');
        this.total = this.querySelector('[data-py-total]');
        this.message = this.querySelector('[data-py-message]');
        this.addEventListener('change', () => this.update());
        this.addEventListener('click', (event) => {
          const selectAll = event.target.closest('[data-py-select-all]');
          const clearAll = event.target.closest('[data-py-clear-all]');
          if (selectAll || clearAll) {
            for (const check of this.querySelectorAll('[data-py-check]')) check.checked = Boolean(selectAll);
            this.update();
          }
          if (event.target.closest('[data-py-add]')) this.addToCart();
        });
        this.update();
      }
      update() {
        let selected = 0;
        let unavailable = 0;
        let subtotal = 0;
        const merged = new Map();
        for (const row of this.querySelectorAll('[data-py-item]')) {
          const option = row.querySelector('[data-py-variant]')?.selectedOptions[0];
          const check = row.querySelector('[data-py-check]');
          if (!option || !check) continue;
          const quantity = Number(option.dataset.quantity || 1);
          const available = option.dataset.available === 'true' && /^\d+$/.test(option.value);
          const status = row.querySelector('[data-py-row-status]');
          if (status) {
            status.hidden = available;
            status.textContent = option.dataset.status || this.dataset.comingSoon;
          }
          const price = row.querySelector('[data-py-price]');
          if (price) price.textContent = Number(option.dataset.price) > 0 ? option.dataset.money : this.dataset.pricePending;
          const photo = row.querySelector('.py-look-item__photo');
          if (photo && option.dataset.image) {
            photo.removeAttribute('srcset');
            photo.src = option.dataset.image;
          }
          if (!check.checked) continue;
          selected += quantity;
          if (!available) {
            unavailable += quantity;
            continue;
          }
          subtotal += Number(option.dataset.price || 0) * quantity;
          const current = merged.get(option.value) || { id: option.value, quantity: 0 };
          current.quantity += quantity;
          merged.set(option.value, current);
        }
        this.items = [...merged.values()];
        const purchasable = this.items.length > 0;
        this.addButton.disabled = this.busy || !purchasable;
        this.addLabel.textContent = this.busy ? this.dataset.loading : purchasable ? this.addLabel.dataset.default : `${this.addLabel.dataset.default} · ${this.dataset.comingSoon}`;
        this.total.hidden = !purchasable;
        this.querySelector('.py-look-detail-v6__note').hidden = !purchasable;
        this.querySelector('[data-py-separator]').hidden = !purchasable;
        this.total.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(subtotal / 100);
        this.querySelector('[data-py-count]').textContent = (this.dataset.countLabel || '([count])').replace('[count]', selected);
        const note = this.querySelector('[data-py-availability]');
        note.hidden = unavailable === 0;
        note.textContent = this.dataset.draftNote;
      }
      async addToCart() {
        if (this.busy || !this.items?.length) return;
        const items = this.items.map((item) => ({ ...item }));
        this.busy = true;
        this.message.textContent = '';
        this.update();
        let sent = false;
        try {
          const root = window.Shopify?.routes?.root || '/';
          sent = true;
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          const result = await response.json();
          if (!response.ok) {
            this.message.textContent = result.description || result.message || this.dataset.error;
            return;
          }
          this.message.textContent = this.dataset.success;
          this.querySelector('[data-py-cart-link]').hidden = false;
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch {
          this.message.textContent = sent ? this.dataset.uncertain : this.dataset.error;
        } finally {
          this.busy = false;
          this.update();
        }
      }
    });
  }
  if (!customElements.get('py-look-gallery-v6')) {
    customElements.define('py-look-gallery-v6', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-py-gallery-thumb]');
          if (!button || !this.contains(button)) return;
          const index = button.dataset.index;
          for (const thumb of this.querySelectorAll('[data-py-gallery-thumb]')) {
            const active = thumb.dataset.index === index;
            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-pressed', String(active));
          }
          for (const panel of this.querySelectorAll('[data-py-gallery-panel]')) {
            const active = panel.dataset.index === index;
            panel.hidden = !active;
            panel.classList.toggle('is-active', active);
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["py-look-detail-v7"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('py-look-picker-v7')) {
  customElements.define('py-look-picker-v7', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      if (!this.querySelector('[data-py-add]')) {
        this.observer?.disconnect();
        this.observer = new MutationObserver(() => this.connectedCallback());
        this.observer.observe(this, {childList: true, subtree: true});
        return;
      }

      this.observer?.disconnect();
      this.initialized = true;
      this.button = this.querySelector('[data-py-add]');
      this.label = this.querySelector('[data-py-add-label]');
      this.defaultLabel = this.label.textContent;
      this.message = this.querySelector('[data-py-message]');

      try {
        this.money = new Intl.NumberFormat(
          this.dataset.locale || 'en',
          {
            style: 'currency',
            currency: this.dataset.currency || 'USD'
          }
        );
      } catch {
        this.money = new Intl.NumberFormat('en', {
          style: 'currency',
          currency: 'USD'
        });
      }

      this.addEventListener('change', event => {
        if (event.target.matches('[data-py-variant]')) {
          event.target
            .closest('[data-py-row]')
            .querySelector('[data-py-check]')
            .checked = true;
        }

        this.message.textContent = '';
        this.update();
      });

      this.addEventListener('click', event => {
        if (event.target.closest('[data-py-add]')) {
          this.addToCart();
        }

        const selectAll = event.target.closest('[data-py-select-all]');
        const clear = event.target.closest('[data-py-clear]');

        if ((selectAll || clear) && !this.busy) {
          for (const check of this.querySelectorAll('[data-py-check]')) {
            check.checked = Boolean(selectAll) && !check.disabled;
          }

          this.update();
        }
      });

      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    update() {
      const merged = new Map();
      let subtotal = 0;
      let unavailable = 0;

      for (const row of this.querySelectorAll('[data-py-row]')) {
        const select = row.querySelector('[data-py-variant]');
        const option = select?.selectedOptions[0];
        const check = row.querySelector('[data-py-check]');

        if (!check) continue;

        const hasPrice =
          option?.dataset.price !== undefined &&
          option.dataset.price !== '' &&
          Number.isFinite(Number(option.dataset.price)) &&
          Number(option.dataset.price) >= 0;

        const quantity = Number(option?.dataset.quantity);

        const available =
          option?.dataset.available === 'true' &&
          /^\d+$/.test(option.value) &&
          hasPrice &&
          Number.isInteger(quantity) &&
          quantity > 0;

        if (!available) {
          check.checked = false;
          unavailable++;
        }

        check.disabled = !available || Boolean(this.busy);

        if (select && select.options.length > 1) {
          select.disabled = Boolean(this.busy);
        }

        const status = row.querySelector('[data-py-row-status]');
        status.hidden = available;
        status.textContent = option?.value
          ? this.dataset.unavailable
          : this.dataset.pending;

        row.querySelector('[data-py-row-price]').textContent = hasPrice
          ? option.dataset.money
          : this.dataset.pending;

        if (!available || !check.checked) continue;

        subtotal += Number(option.dataset.price) * quantity;

        const current = merged.get(option.value) || {
          id: option.value,
          quantity: 0
        };

        current.quantity += quantity;
        merged.set(option.value, current);
      }

      this.items = [...merged.values()];

      this.button.disabled =
        Boolean(this.busy) ||
        !this.items.length ||
        Boolean(this.uncertain);

      this.label.textContent = this.busy
        ? this.dataset.loading
        : this.defaultLabel;

      this.querySelector('[data-py-total]').textContent =
        this.money.format(subtotal / 100);

      const partial = this.querySelector('[data-py-partial]');
      partial.hidden = unavailable === 0;
      partial.textContent = this.dataset.partial;

      for (const control of this.querySelectorAll(
        '[data-py-select-all], [data-py-clear]'
      )) {
        control.disabled = Boolean(this.busy);
      }
    }

    async addToCart() {
      if (this.busy || this.uncertain) return;

      this.update();

      if (!this.items.length) {
        this.message.textContent = this.dataset.empty;
        return;
      }

      const items = this.items.map(item => ({...item}));

      this.busy = true;
      this.message.textContent = '';
      this.update();

      let sent = false;

      try {
        const root = window.Shopify?.routes?.root || '/';
        sent = true;

        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({items})
        });

        const result = await response.json();

        if (!response.ok) {
          this.message.textContent =
            result.description ||
            result.message ||
            this.dataset.error;
          return;
        }

        this.message.textContent = this.dataset.success;
        this.querySelector('[data-py-cart]').hidden = false;

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {bubbles: true})
        );
      } catch {
        this.uncertain = sent;
        this.message.textContent = sent
          ? this.dataset.uncertain
          : this.dataset.error;

        this.querySelector('[data-py-cart]').hidden = !sent;
      } finally {
        this.busy = false;
        this.update();
      }
    }
  });
}

if (!window.pyLookV7EventsBound) {
  window.pyLookV7EventsBound = true;

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-py-open-chooser]');
    if (!trigger) return;

    const target = document.getElementById(
      trigger.dataset.pyOpenChooser
    );
    if (!target) return;

    event.preventDefault();
    target.open = true;
    target.querySelector('summary')?.focus();

    target.scrollIntoView({
      block: 'nearest',
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth'
    });
  });

  document.addEventListener('shopify:block:select', event => {
    const detail = event.target.closest('.py-look-v7__chooser');
    if (detail) detail.open = true;
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["py-shop-the-look-v4"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('py-look-collection-v4')) {
    customElements.define('py-look-collection-v4', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-py-look-filter]');
          if (!button || !this.contains(button)) return;
          const filter = button.dataset.pyLookFilter;
          for (const option of this.querySelectorAll('[data-py-look-filter]')) {
            const active = option === button;
            option.classList.toggle('is-active', active);
            option.setAttribute('aria-pressed', String(active));
          }
          for (const card of this.querySelectorAll('[data-py-look-card]')) {
            const tags = ` ${card.dataset.pyLookTags || ''} `;
            card.hidden = filter !== 'all' && !tags.includes(` ${filter} `);
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["py-shop-the-look-v5"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('py-look-collection-v5')) {
    customElements.define('py-look-collection-v5', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-py-look-filter]');
          if (!button || !this.contains(button)) return;
          const filter = button.dataset.pyLookFilter;
          for (const option of this.querySelectorAll('[data-py-look-filter]')) {
            const active = option === button;
            option.classList.toggle('is-active', active);
            option.setAttribute('aria-pressed', String(active));
          }
          for (const card of this.querySelectorAll('[data-py-look-card]')) {
            const tags = ` ${card.dataset.pyLookTags || ''} `;
            card.hidden = filter !== 'all' && !tags.includes(` ${filter} `);
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["py-shop-the-look-v6"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('py-look-collection-v6')) {
    customElements.define('py-look-collection-v6', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-py-look-filter]');
          if (!button || !this.contains(button)) return;
          const filter = button.dataset.pyLookFilter;
          for (const option of this.querySelectorAll('[data-py-look-filter]')) {
            const active = option === button;
            option.classList.toggle('is-active', active);
            option.setAttribute('aria-pressed', String(active));
          }
          for (const card of this.querySelectorAll('[data-py-look-card]')) {
            const tags = ` ${card.dataset.pyLookTags || ''} `;
            card.hidden = filter !== 'all' && !tags.includes(` ${filter} `);
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
